import React from "react";
import ScoreSection from "./scoreSection";
import PlayersSection from "./playersSection";
import { connect } from "react-redux";

const ScoresResultView = (props) => {
  let roomData = props.gameReducer.roomobj;
  return (
    <div className="dw20-ScoresResultView">
      <ScoreSection />
      {/* <PlayersSection /> */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ScoresResultView);
